"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var Money_1 = __importDefault(require("components/Money"));
var DoubleCell_1 = __importDefault(require("containers/TableMaker/components/DoubleCell"));
var single_1 = require("utils/selectors/single");
var context_1 = require("../context");
var utils_1 = require("../utils");
var Amount = function (_a) {
    var _b;
    var item = _a.item;
    var showCurrencySource = (0, react_1.useContext)(context_1.ShowCurrencyContext);
    var myCompany = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var amountInTransactionCurrency = (_b = (!item.isLineItem ? (item === null || item === void 0 ? void 0 : item.subTotal) || item.total : item.amount)) !== null && _b !== void 0 ? _b : 0;
    var amountInBaseCurrency = myCompany ? (0, utils_1.convertTxnAmount)(myCompany)(item) : 0;
    return ((0, jsx_runtime_1.jsx)(DoubleCell_1.default, { main: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: amountInBaseCurrency, currency: "", fixedDecimals: true }), secondary: showCurrencySource && ((0, jsx_runtime_1.jsx)(Money_1.default, { amount: amountInTransactionCurrency, currency: "", fixedDecimals: true })), secondaryProps: { color: 'riverstone' } }));
};
exports.default = Amount;
